import type {DismissalDuration} from '../../types'

export const DEFAULT_COOKIE_EXPIRATION_DAYS = 30

export const DISMISSAL_DURATION_OPTIONS: DismissalDuration[] = [
  {id: 'one-day', text: 'One day', days: 1},
  {id: 'one-week', text: 'One week', days: 7},
  {id: 'one-month', text: 'One month', days: DEFAULT_COOKIE_EXPIRATION_DAYS},
  {id: 'indefinitely', text: 'Never', days: null},
]

export const getDefaultDurationIndex = (): number => {
  return DISMISSAL_DURATION_OPTIONS.findIndex(option => option.days === DEFAULT_COOKIE_EXPIRATION_DAYS)
}
